// extracted by mini-css-extract-plugin
export default {"landing":"landing_landing__S2exU","row":"landing_row__nM3ba"};